var m = require('mithril');
var animations = require('../../libs/animations');

var alerts = {};

alerts.vm = {
  alertCount : 0,
  alerts : [],
  add : function (header, detail) {
    if (alerts.vm.alerts.length < 3) {
      alerts.vm.alerts.push({id : "alert" + alerts.vm.alertCount, header: header, detail:detail});
    }
    alerts.vm.alertCount += 1;
  },
  remove : function (alertObj) {
    alerts.vm.alerts.splice(alerts.vm.alerts.indexOf(alertObj), 1);
  },
  clear : function () {
    alerts.vm.alerts.splice(0);
  }
}

alerts.view = function () {
  var vm = this.vm;
  return [
    vm.alerts.map(function (alertObj){
      return m("div.flex.justify-between.relative.br3.mh2.mb3.pa1.bg-red", {style:{overflow: "hidden"},id: "alert" + alertObj.id}, [
        m("p.ma1", alertObj.header.detail),
        m('i.icon.ion-close.ma1',{class:"close", onclick: animations.flyOut(vm.remove.bind(this, alertObj), "alert"+alertObj.id)})
      ])
    })
  ]
}

module.exports = alerts;
